// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lcReadingAdd {
  display: flex;
  flex-direction: column;
  align-items: start;
  max-width: var(--lc-content-width);
  padding: 0 10px;
  margin: var(--lc-margin-big) auto;

  & p {
    line-height: var(--lc-line-height);
  }

  & label {
    color: var(--lc-accent-color);
    font-weight: bold;
    font-size: var(--font-size-normal);
    margin-block: 6px;
  }
}

.lcReadingListFiles {
  max-width: var(--lc-content-width);
  margin: var(--lc-margin-medium) auto;
  border: 1px solid var(--light-border);
  border-radius: 5px;
  margin-block: 24px;
}

.lcReadingTextArea {
  margin-bottom: var(--lc-margin-medium);
  /* Only allow the textarea to grow vertically */
  width: 100% !important;
  box-sizing: border-box;
  min-height: 300px;
  padding: 20px;
  box-sizing: border-box;
}


.lcReadingTitleInput {
  margin-bottom: var(--lc-margin-medium);
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
}

.lcReadingErrorMessage {
  background: #ffbfbf;
  padding: 15px;
  border-radius: 3px;
  border: 1px solid #f00;
  margin-bottom: 10px;
  width: 100%;
  font-size: var(--font-size-normal);
  box-sizing: border-box;
}

.lcReadingRendered {
  overflow: hidden;
  position: relative;
  min-height: 100%;
  & h1 {
    margin-top: 0;
    border-bottom: 1px solid var(--light-border);
  }
}

.lcReadingStickyHeader {
  margin-left: 15px;
  text-align: right;
  position: sticky;
  top: var(--lc-header-height);
  height: var(--lc-sticky-header-adjust);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  z-index: 1;
}

.lcReadingStickyHeaderRow {
  display: flex;
  flex-direction: row;
  gap: 6px;
}

.lcReadingStickyHeaderRow {
  background: #fff;
  padding: 7px;
  padding-inline-end: 0;
  border-radius: 5px;
}

.lcReadingSolo {
  position: relative;
}

.lcReadingContainer {
  --reading-padding: 32px;
  max-width: 1000px;
  line-height: var(--lc-line-height);
  font-size: 16px;
}

.splitterSolo {
  & .lcReadingContainer {
    margin: var(--reading-padding) auto;
    width: calc(100vw - 4 * var(--reading-padding));
    display: flex;
    margin-bottom: 0;
  }

  & .lcReadingLeft {
    border: 1px solid var(--light-border);
    border-right: none;
    border-radius: 6px;
    padding-top: calc(var(--reading-padding) - var(--lc-sticky-header-adjust));
   }
}

.lcReadingStems {
  flex-shrink: 0;
  border: var(--lc-accent-color) 1px solid;
  border-left-width: 2px;
  background: rgba(var(--lc-accent-color-rgb), 0.1);
  border-radius: 0 6px 6px 0;
  position: sticky;
  top: 0;
  max-height: calc(100vh);

  & h2 {
    text-align: center;
    color: #fff;
    margin: 0;
    background: var(--lc-accent-color);
    height: var(--header-height);
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-inline: 25px;
  }
}

.lcReadingStemsScroll {
  max-height: calc(100vh - var(--header-height));
  padding-block: 10px;
  box-sizing: border-box;
  overflow-y: scroll;
  min-height: calc(
    100vh
      - var(--header-height) * 2
      - var(--lc-header-height)
      - var(--reading-padding) * 2
  );
}

.lcReadingHovered {
  background-color: var(--lc-accent-color);
  color: #fff;
  outline: 2px solid var(--lc-accent-color);
  border-radius: 2px;
  display: inline-block;
  transition: background 500ms;
}

.lcReadingStemsRow {
  display: grid;
  grid-template-columns: 1fr 0fr 0fr;
  padding: 2px 10px;

  &.selected {
    outline: 1px solid var(--lc-accent-color);
    border-radius: 3px;
    background-color: var(--lc-accent-color);
    color: #fff;
  }

  .lcReadingStems:not(:focus) &.selected {
    background-color: rgba(var(--lc-accent-color-rgb), 0.2);
    outline-color: rgba(var(--lc-accent-color-rgb), 0.2);
    color: #000;
  }
}

.lcReadingStemCount {
  text-align: center;
  /* Copying this text is kind of annoying. */
  user-select: none;

  & > span {
    background-color: #fff;
    border-radius: 12px;
    color: var(--lc-accent-color);
    padding: 5px;
    font-size: 12px;
    outline: 1px solid var(--lc-accent-color);
    margin-left: 0.5em;
  }
}

.lcReadingButtons {
  padding: 0.1em 0.4em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 3px;
}

.lcReadingButton {
  padding: 0.1em 0.4em;
}

.lcReadingLeft {
  flex: 1;
  padding: var(--reading-padding);
}

.lcReadingAddButton {
  font-size: 1.0em;
}

.lcReadingSelectedSentence {
  background: rgba(var(--lc-accent-color-rgb), 0.2);
}

.lcReadingTop {
  display: flex;
  flex-direction: column;
  align-items: start;
  max-width: var(--lc-content-width);
  padding: 0 10px;
  margin: 30px auto;
  --slidedown-px: -20px;
  animation: slidedown 500ms;
}

.lcReadingOverlay {
  position: absolute;
  /* Sync with the margin value in JS. */
  width: calc(100vw - 20px);
  max-width: 600px;
  padding: 20px;
  line-height: 1.4;
  background-color: #fff;
  border: 1px solid var(--button-border);
  border-radius: 6px;
  box-shadow: 0 0.3em 0.6em #0003;
  --slidedown-px: -10px;
  animation: slidedown 200ms;
}

.lcReadingTranslation {
  border-bottom: 1px solid #aaa;
  padding-bottom: 13px;
  margin-bottom: 16px;
}

.lcReadingWord {
  margin-top: 12px;
}

.lcReadingWordWord {
  font-weight: bold;
}

.lcReadingWordGender {
  color: #00abff;
  font-style: italic;
}

.lcReadingWordPOS {
  font-style: italic;
  color: #ff7800;
}

.lcReadingDefinition {
  color: #666;
}

.lcReadingCommentedParagraph {
  color: #777;
}

.lcReadingWordSection {
  display: flex;
  flex-direction: row;
}

.lcReadingTooltipButtons {
  flex-grow: 0;
}

.lcReadingWordSection {
  flex-direction: row;
}

.lcReadingTooltipButtons {
  flex-shrink: 0;
  display: flex;
}

.lcReadingWord {
  flex: 1;
}

.lcReadingOverlay .lcReadingStemCount > span {
  position: relative;
  top: 8px;
}

.lcReadingOverlayUnknownWord:hover {
  background: rgba(var(--lc-accent-color-rgb), 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/LanguageCoach/Reading.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,iCAAiC;;EAEjC;IACE,kCAAkC;EACpC;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,kCAAkC;IAClC,iBAAiB;EACnB;AACF;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,+CAA+C;EAC/C,sBAAsB;EACtB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,sCAAsC;EACtC,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB;IACE,aAAa;IACb,4CAA4C;EAC9C;AACF;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE;IACE,mCAAmC;IACnC,+CAA+C;IAC/C,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,0EAA0E;GAC3E;AACH;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,sBAAsB;EACtB,iDAAiD;EACjD,0BAA0B;EAC1B,gBAAgB;EAChB,MAAM;EACN,uBAAuB;;EAEvB;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,kCAAkC;IAClC,4BAA4B;IAC5B,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB;;;;;GAKC;AACH;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,iBAAiB;;EAEjB;IACE,yCAAyC;IACzC,kBAAkB;IAClB,wCAAwC;IACxC,WAAW;EACb;;EAEA;IACE,uDAAuD;IACvD,oDAAoD;IACpD,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,iBAAiB;;EAEjB;IACE,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,yCAAyC;IACzC,kBAAkB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,iDAAiD;AACnD","sourcesContent":[".lcReadingAdd {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  max-width: var(--lc-content-width);\n  padding: 0 10px;\n  margin: var(--lc-margin-big) auto;\n\n  & p {\n    line-height: var(--lc-line-height);\n  }\n\n  & label {\n    color: var(--lc-accent-color);\n    font-weight: bold;\n    font-size: var(--font-size-normal);\n    margin-block: 6px;\n  }\n}\n\n.lcReadingListFiles {\n  max-width: var(--lc-content-width);\n  margin: var(--lc-margin-medium) auto;\n  border: 1px solid var(--light-border);\n  border-radius: 5px;\n  margin-block: 24px;\n}\n\n.lcReadingTextArea {\n  margin-bottom: var(--lc-margin-medium);\n  /* Only allow the textarea to grow vertically */\n  width: 100% !important;\n  box-sizing: border-box;\n  min-height: 300px;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n\n.lcReadingTitleInput {\n  margin-bottom: var(--lc-margin-medium);\n  padding: 10px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.lcReadingErrorMessage {\n  background: #ffbfbf;\n  padding: 15px;\n  border-radius: 3px;\n  border: 1px solid #f00;\n  margin-bottom: 10px;\n  width: 100%;\n  font-size: var(--font-size-normal);\n  box-sizing: border-box;\n}\n\n.lcReadingRendered {\n  overflow: hidden;\n  position: relative;\n  min-height: 100%;\n  & h1 {\n    margin-top: 0;\n    border-bottom: 1px solid var(--light-border);\n  }\n}\n\n.lcReadingStickyHeader {\n  margin-left: 15px;\n  text-align: right;\n  position: sticky;\n  top: var(--lc-header-height);\n  height: var(--lc-sticky-header-adjust);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  z-index: 1;\n}\n\n.lcReadingStickyHeaderRow {\n  display: flex;\n  flex-direction: row;\n  gap: 6px;\n}\n\n.lcReadingStickyHeaderRow {\n  background: #fff;\n  padding: 7px;\n  padding-inline-end: 0;\n  border-radius: 5px;\n}\n\n.lcReadingSolo {\n  position: relative;\n}\n\n.lcReadingContainer {\n  --reading-padding: 32px;\n  max-width: 1000px;\n  line-height: var(--lc-line-height);\n  font-size: 16px;\n}\n\n.splitterSolo {\n  & .lcReadingContainer {\n    margin: var(--reading-padding) auto;\n    width: calc(100vw - 4 * var(--reading-padding));\n    display: flex;\n    margin-bottom: 0;\n  }\n\n  & .lcReadingLeft {\n    border: 1px solid var(--light-border);\n    border-right: none;\n    border-radius: 6px;\n    padding-top: calc(var(--reading-padding) - var(--lc-sticky-header-adjust));\n   }\n}\n\n.lcReadingStems {\n  flex-shrink: 0;\n  border: var(--lc-accent-color) 1px solid;\n  border-left-width: 2px;\n  background: rgba(var(--lc-accent-color-rgb), 0.1);\n  border-radius: 0 6px 6px 0;\n  position: sticky;\n  top: 0;\n  max-height: calc(100vh);\n\n  & h2 {\n    text-align: center;\n    color: #fff;\n    margin: 0;\n    background: var(--lc-accent-color);\n    height: var(--header-height);\n    padding: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-inline: 25px;\n  }\n}\n\n.lcReadingStemsScroll {\n  max-height: calc(100vh - var(--header-height));\n  padding-block: 10px;\n  box-sizing: border-box;\n  overflow-y: scroll;\n  min-height: calc(\n    100vh\n      - var(--header-height) * 2\n      - var(--lc-header-height)\n      - var(--reading-padding) * 2\n  );\n}\n\n.lcReadingHovered {\n  background-color: var(--lc-accent-color);\n  color: #fff;\n  outline: 2px solid var(--lc-accent-color);\n  border-radius: 2px;\n  display: inline-block;\n  transition: background 500ms;\n}\n\n.lcReadingStemsRow {\n  display: grid;\n  grid-template-columns: 1fr 0fr 0fr;\n  padding: 2px 10px;\n\n  &.selected {\n    outline: 1px solid var(--lc-accent-color);\n    border-radius: 3px;\n    background-color: var(--lc-accent-color);\n    color: #fff;\n  }\n\n  .lcReadingStems:not(:focus) &.selected {\n    background-color: rgba(var(--lc-accent-color-rgb), 0.2);\n    outline-color: rgba(var(--lc-accent-color-rgb), 0.2);\n    color: #000;\n  }\n}\n\n.lcReadingStemCount {\n  text-align: center;\n  /* Copying this text is kind of annoying. */\n  user-select: none;\n\n  & > span {\n    background-color: #fff;\n    border-radius: 12px;\n    color: var(--lc-accent-color);\n    padding: 5px;\n    font-size: 12px;\n    outline: 1px solid var(--lc-accent-color);\n    margin-left: 0.5em;\n  }\n}\n\n.lcReadingButtons {\n  padding: 0.1em 0.4em;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  gap: 3px;\n}\n\n.lcReadingButton {\n  padding: 0.1em 0.4em;\n}\n\n.lcReadingLeft {\n  flex: 1;\n  padding: var(--reading-padding);\n}\n\n.lcReadingAddButton {\n  font-size: 1.0em;\n}\n\n.lcReadingSelectedSentence {\n  background: rgba(var(--lc-accent-color-rgb), 0.2);\n}\n\n.lcReadingTop {\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  max-width: var(--lc-content-width);\n  padding: 0 10px;\n  margin: 30px auto;\n  --slidedown-px: -20px;\n  animation: slidedown 500ms;\n}\n\n.lcReadingOverlay {\n  position: absolute;\n  /* Sync with the margin value in JS. */\n  width: calc(100vw - 20px);\n  max-width: 600px;\n  padding: 20px;\n  line-height: 1.4;\n  background-color: #fff;\n  border: 1px solid var(--button-border);\n  border-radius: 6px;\n  box-shadow: 0 0.3em 0.6em #0003;\n  --slidedown-px: -10px;\n  animation: slidedown 200ms;\n}\n\n.lcReadingTranslation {\n  border-bottom: 1px solid #aaa;\n  padding-bottom: 13px;\n  margin-bottom: 16px;\n}\n\n.lcReadingWord {\n  margin-top: 12px;\n}\n\n.lcReadingWordWord {\n  font-weight: bold;\n}\n\n.lcReadingWordGender {\n  color: #00abff;\n  font-style: italic;\n}\n\n.lcReadingWordPOS {\n  font-style: italic;\n  color: #ff7800;\n}\n\n.lcReadingDefinition {\n  color: #666;\n}\n\n.lcReadingCommentedParagraph {\n  color: #777;\n}\n\n.lcReadingWordSection {\n  display: flex;\n  flex-direction: row;\n}\n\n.lcReadingTooltipButtons {\n  flex-grow: 0;\n}\n\n.lcReadingWordSection {\n  flex-direction: row;\n}\n\n.lcReadingTooltipButtons {\n  flex-shrink: 0;\n  display: flex;\n}\n\n.lcReadingWord {\n  flex: 1;\n}\n\n.lcReadingOverlay .lcReadingStemCount > span {\n  position: relative;\n  top: 8px;\n}\n\n.lcReadingOverlayUnknownWord:hover {\n  background: rgba(var(--lc-accent-color-rgb), 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
